import { createFileRoute } from '@tanstack/react-router'

/**
 * A lista vive no layout pathless `_pagar`. Esta rota existe só para dar a URL
 * /pagamentos/pagar — e renderiza nada, porque o conteúdo já está montado acima.
 */
export const Route = createFileRoute('/_authed/pagamentos/_pagar/pagar')({
  component: () => null,
})
